import { Button, Dropdown, Menu } from 'antd'
import { DownOutlined, EyeOutlined, EditOutlined } from '@ant-design/icons'

type FieldUpdateDelete = {
    canRenew: boolean,
    hanldeView: Function,
    hanldeRenew: Function,
}

export default function ActionViewRenew({ canRenew, hanldeView, hanldeRenew }: FieldUpdateDelete) {
    return (
        <Dropdown
            overlay={
                <Menu>
                    <Menu.Item>
                        <Button
                            onClick={() => hanldeView()}
                            icon={<EyeOutlined />}
                            type='primary'
                        >
                            Chi tiết
                        </Button>
                    </Menu.Item>
                    {canRenew && (
                        <Menu.Item>
                            <Button
                                onClick={() => hanldeRenew()}
                                icon={<EditOutlined />}
                                type='primary'
                                danger
                            >
                                Gia hạn
                            </Button>
                        </Menu.Item>
                    )}
                </Menu>
            }
        >
            <Button style={{ background: '#289e45', color: 'white' }}>
                Chức năng <DownOutlined />
            </Button>
        </Dropdown>
    )
}
